module.exports = __webpack_public_path__ + "img/drive_drive_off.c95a6b1a.svg";